import produce from 'immer'

import {
  FETCH_EXCLUSION_FILES,
  FETCH_EXCLUSION_FILES_SUCCESS,
  FETCH_EXCLUSION_FILES_FAILURE,
  FETCH_EXCLUSION_FILE,
  FETCH_EXCLUSION_FILE_SUCCESS,
  FETCH_EXCLUSION_FILE_FAILURE,
  UPDATE_EXCLUSION_FILE,
  UPDATE_EXCLUSION_FILE_SUCCESS,
  UPDATE_EXCLUSION_FILE_FAILURE,
  REMOVE_EXCLUSION_FILE,
  REMOVE_EXCLUSION_FILE_SUCCESS,
  REMOVE_EXCLUSION_FILE_FAILURE,
} from '../actions/types'

export const initialFileState = {
  id: '',
  name: null,
  lastModified: null,
  size: null,
  storageClass: null,
  content: '',
  fetching: false,
  fetched: false,
  error: null,
  updating: false,
  removing: false,
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_EXCLUSION_FILES: {
      draft.fetching = true
      break
    }
    case FETCH_EXCLUSION_FILES_SUCCESS: {
      const files = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Add all statuses to state
      draft.allIds = []
      draft.byId = {}
      for (const file of files) {
        const id = file.name
        if (draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...initialFileState,
          ...file,
          id,
        }
      }

      break
    }
    case FETCH_EXCLUSION_FILES_FAILURE: {
      const error = payload
      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    case FETCH_EXCLUSION_FILE: {
      const fileName = payload
      const file = draft.byId[fileName]
      file.fetching = true
      break
    }
    case FETCH_EXCLUSION_FILE_SUCCESS: {
      const { fileName, content } = payload
      const file = draft.byId[fileName]
      file.error = null
      file.fetching = false
      file.fetched = true
      file.content = content
      break
    }
    case FETCH_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      const file = draft.byId[fileName]
      file.error = error
      file.fetching = false
      file.fetched = true
      break
    }
    case UPDATE_EXCLUSION_FILE: {
      const { fileName } = payload
      draft.byId[fileName].updating = true
      break
    }
    case UPDATE_EXCLUSION_FILE_SUCCESS: {
      const fileName = payload
      draft.byId[fileName].updating = false
      break
    }
    case UPDATE_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      draft.byId[fileName].updating = false
      draft.byId[fileName].error = error
      break
    }
    case REMOVE_EXCLUSION_FILE: {
      const fileName = payload
      draft.byId[fileName].removing = true
      break
    }
    case REMOVE_EXCLUSION_FILE_SUCCESS: {
      const fileName = payload
      draft.byId[fileName].removing = false
      break
    }
    case REMOVE_EXCLUSION_FILE_FAILURE: {
      const { fileName, error } = payload
      draft.byId[fileName].removing = false
      draft.byId[fileName].error = error
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
